import { render, staticRenderFns } from "./managementDetail.vue?vue&type=template&id=00dd4ed2&scoped=true"
import script from "./managementDetail.vue?vue&type=script&lang=js"
export * from "./managementDetail.vue?vue&type=script&lang=js"
import style0 from "./managementDetail.vue?vue&type=style&index=0&id=00dd4ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd4ed2",
  null
  
)

export default component.exports